// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Admin_Login_Bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/authLoginBg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General styling */
.login_main {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(209deg, #fbf6ff 0%, #fff1ee 46.5%, #f1f6ff 100%);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
}
.changepassword_main {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background: linear-gradient(209deg, #fbf6ff 0%, #fff1ee 46.5%, #f1f6ff 100%); */
}

.login_container {
  width: 500px;
  max-width: 90%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.inputContainer {
  width: 100%;
  height: fit-content;
  background: linear-gradient(209deg, #fbf6ff 0%, #fff1ee 46.5%, #f1f6ff 100%);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: cover;
  padding: 40px;
  border: 1px solid #ffffff;
  box-shadow: -6px 10px 40px 0px #00000014;
  border-radius: 10px;
}

.inputContainer h1 {
  color: #000000;
  font-weight: 500;
  font-size: 24px;
  text-align: center;
}

.login_container img {
  width: 240px;
  height: 77px;
}

.userInput label {
  color: #000000;
  font-weight: 500;
  font-size: 16px;
}

.userInput > input {
  border: 1px solid #515151;
  border-radius: 6px;
  outline: none;
  padding: 12px 20px;
  background-color: transparent;
  font-size: 16px;
  font-weight: 500;
}

.userInput > div {
  border: 1px solid #515151;
  border-radius: 6px;
  padding: 12px 20px;
}

.userInput > div > input {
  outline: none;
  width: 95%;
  height: 100%;
  border: none;
  border-radius: inherit;
  font-size: 16px;
  font-weight: 500;
  background-color: transparent;
}

.authButton {
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  width: 100%;
  height: 54px;
  font-size: 18px;
  display: flex;
  gap: 1.2rem;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 4px 0px #00000040;
  border-radius: 38px;
  border: 3px solid transparent;
  background: linear-gradient(90deg, #234b9a, #234b9a, #234b9a) padding-box,
    linear-gradient(180deg, #234b9a 0%, #ffffff 100%) border-box;
}

.forgot_passtext {
  font-size: 16px;
  font-weight: 700;
  color: #234b9a;
  text-decoration: underline;
  padding-top: 5px;
  cursor: pointer;
}

.input-feedback {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #d9534f;
}

.input-error {
  border-color: #d9534f;
}

/* Media queries */
@media screen and (max-width: 768px) {
  .login_container {
    width: 95%;
    padding: 20px;
  }

  .inputContainer {
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Auth/Auth.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4EAA4E;EAC5E,yDAAwD;EACxD,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kFAAkF;AACpF;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,4EAA4E;EAC5E,yDAAqD;EACrD,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B;gEAC8D;AAChE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* General styling */\n.login_main {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(209deg, #fbf6ff 0%, #fff1ee 46.5%, #f1f6ff 100%);\n  background-image: url(\"../../assets/Admin_Login_Bg.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.changepassword_main {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* background: linear-gradient(209deg, #fbf6ff 0%, #fff1ee 46.5%, #f1f6ff 100%); */\n}\n\n.login_container {\n  width: 500px;\n  max-width: 90%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.inputContainer {\n  width: 100%;\n  height: fit-content;\n  background: linear-gradient(209deg, #fbf6ff 0%, #fff1ee 46.5%, #f1f6ff 100%);\n  background-image: url(\"../../assets/authLoginBg.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  padding: 40px;\n  border: 1px solid #ffffff;\n  box-shadow: -6px 10px 40px 0px #00000014;\n  border-radius: 10px;\n}\n\n.inputContainer h1 {\n  color: #000000;\n  font-weight: 500;\n  font-size: 24px;\n  text-align: center;\n}\n\n.login_container img {\n  width: 240px;\n  height: 77px;\n}\n\n.userInput label {\n  color: #000000;\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.userInput > input {\n  border: 1px solid #515151;\n  border-radius: 6px;\n  outline: none;\n  padding: 12px 20px;\n  background-color: transparent;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.userInput > div {\n  border: 1px solid #515151;\n  border-radius: 6px;\n  padding: 12px 20px;\n}\n\n.userInput > div > input {\n  outline: none;\n  width: 95%;\n  height: 100%;\n  border: none;\n  border-radius: inherit;\n  font-size: 16px;\n  font-weight: 500;\n  background-color: transparent;\n}\n\n.authButton {\n  color: #ffffff;\n  font-size: 20px;\n  font-weight: 700;\n  width: 100%;\n  height: 54px;\n  font-size: 18px;\n  display: flex;\n  gap: 1.2rem;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0px 4px 4px 0px #00000040;\n  border-radius: 38px;\n  border: 3px solid transparent;\n  background: linear-gradient(90deg, #234b9a, #234b9a, #234b9a) padding-box,\n    linear-gradient(180deg, #234b9a 0%, #ffffff 100%) border-box;\n}\n\n.forgot_passtext {\n  font-size: 16px;\n  font-weight: 700;\n  color: #234b9a;\n  text-decoration: underline;\n  padding-top: 5px;\n  cursor: pointer;\n}\n\n.input-feedback {\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: #d9534f;\n}\n\n.input-error {\n  border-color: #d9534f;\n}\n\n/* Media queries */\n@media screen and (max-width: 768px) {\n  .login_container {\n    width: 95%;\n    padding: 20px;\n  }\n\n  .inputContainer {\n    padding: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
